var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"close-img",attrs:{"src":require("@/assets/svg/close.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }